<template>
    <div>
        <div v-if="line" class="nj-line"></div>
        <div class="nj-flx">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "Buttons",
    components: {
        
    },
    props: {
        line: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>

<style scoped></style>